import { createContext } from 'react';

import { AviosAuthContextValue } from '../core/types';

export const AviosAuthContext = createContext<AviosAuthContextValue | null>(null);
